import { Outlet } from 'react-router-dom';
import ChatSubSidebar from '../components/chat/ChatSubSidebar';

export default function ChatLayout() {
  return (
    <div className="flex -m-6" style={{ height: 'calc(100% + 48px)' }}>
      <ChatSubSidebar />
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
